import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { config } from '../../../../../config/index';
import placeholderImage from '../../../../../assets/images/placeholder.jpg';
const { API_URL, SERVER_URL } = config;

const SupervisorDetail = ({ history, match: { params } }) => {
  const supervisor_id = parseInt(params.supervisor_id);
  const token = localStorage.getItem('token');

  const [supervisor, setSupervisor] = useState({});
  const [supervisorSites, setSupervisorSites] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [lastDayDate, setLastDayDate] = useState(null);
  const [resignDate, setResignDate] = useState(null);

  const fetchSupervisor = async () => {
    const url = `${API_URL}/supervisor/${supervisor_id}`;

    if (token) {
      let response = await fetch(url, {
        mode: 'cors',
        method: 'GET',
        withCredentials: true,
        headers: {
          Authorization: token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        let data = await response.json();
        setSupervisor(data.data);
      } else {
        console.log(response.message);
      }
    } else {
      console.log('Token is missing');
    }
  };

  useEffect(() => {
    fetchSupervisor();
  }, []);

  useEffect(() => {
    if (supervisor && supervisor.sites) {
      setSupervisorSites(supervisor.sites);
    } else {
      setSupervisorSites(null);
    }
  }, [supervisor]);

  useEffect(() => {
    if (supervisorSites) {
      const sortStartDate = [...supervisorSites].sort(
        (a, b) =>
          moment(a.start_date).format('YYYYMMDD') -
          moment(b.start_date).format('YYYYMMDD')
      );
      const sortLastDayDate = [...supervisorSites].sort(
        (a, b) =>
          moment(a.last_day_date).format('YYYYMMDD') -
          moment(b.last_day_date).format('YYYYMMDD')
      );
      const sortResignDate = [...supervisorSites].sort(
        (a, b) =>
          moment(a.resign_date).format('YYYYMMDD') -
          moment(b.resign_date).format('YYYYMMDD')
      );

      const startDateObj = sortStartDate.length > 0 ? sortStartDate[0] : null;
      const lastDayDateObj =
        sortLastDayDate.length > 0 ? sortLastDayDate.pop() : null;
      const resignDateObj =
        sortResignDate.length > 0 ? sortResignDate.pop() : null;

      const startDate =
        startDateObj && startDateObj.start_date
          ? moment(startDateObj.start_date).format('DD/MM/YYYY')
          : '-';
      const lastDayDate =
        lastDayDateObj && lastDayDateObj.last_day_date
          ? moment(lastDayDateObj.last_day_date).format('DD/MM/YYYY')
          : '-';
      const resignDate =
        resignDateObj && resignDateObj.resign_date
          ? moment(resignDateObj.resign_date).format('DD/MM/YYYY')
          : '-';

      setStartDate(startDate);
      setLastDayDate(lastDayDate);
      setResignDate(resignDate);
    }
  }, [supervisorSites]);

  return (
    <React.Fragment>
      <div
        className="d-flex bg-white justify-content-between "
        style={{ padding: '3rem', background: '#3c3c3c' }}
      >
        <div className="d-flex flex-column">
          <NavLink
            to="/supervisors"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div>
              <i className="fas fa-chevron-left pe-2"></i> Supervisor Management
            </div>
          </NavLink>
          <div className="d-flex align-items-center justify-content-center pt-4">
            <div>
              <img
                src={
                  supervisor.image
                    ? `${SERVER_URL}/${supervisor.image}`
                    : placeholderImage
                }
                alt="default"
                className="rounded-circle me-3"
                style={{ height: '6rem', width: '6rem' }}
              />
            </div>
            <div className="d-flex flex-column">
              <h3>
                {supervisor.first_name} {supervisor.last_name}
              </h3>
              <div className="d-flex">
                <span className="badge rounded-pill bg-secondary">
                  Supervisor
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-auto">
          <button
            onClick={() =>
              history.push(`/supervisors/supervisor/${supervisor.id}/edit`)
            }
            className="btn btn-outline-brand rounded"
            style={{ width: '200px' }}
          >
            Edit Profile
          </button>
        </div>
      </div>
      <div
        className="card bg-white text-dark shadow rounded"
        style={{ margin: '3rem' }}
      >
        <div className="card-body">
          <div className="container-fluid d-flex">
            <div style={{ width: '15rem' }} className="p-2 m-2">
              <strong>Supervisor Information</strong>
              <p className="pt-2 text-muted">
                View and edit supervisor information
              </p>
            </div>
            <div className="flex-grow-1 p-2 m-2">
              <div className="row pb-3">
                <div className="col-sm-4">
                  <strong>First Name</strong>
                  <p className="pt-2">{supervisor.first_name}</p>
                </div>
                <div className="col-sm-4">
                  <strong>Last Name</strong>
                  <p className="pt-2">{supervisor.last_name}</p>
                </div>
              </div>
              <div className="row pb-3">
                <div className="col-sm-4">
                  <strong>Employee No.</strong>
                  <p className="pt-2">{supervisor.employee_no}</p>
                </div>
                <div className="col-sm-4">
                  <strong>Employee ID</strong>
                  <p className="pt-2">{supervisor.employee_id}</p>
                </div>
              </div>
              <div className="row pb-3">
                <div className="col-sm-4">
                  <strong>Gender</strong>
                  <p className="pt-2">
                    {supervisor.gender_id === 1 ? 'Male' : 'Female'}
                  </p>
                </div>
                <div className="col-sm-4">
                  <strong>Race</strong>
                  <p className="pt-2">
                    {supervisor.race_id === 1
                      ? 'Chinese'
                      : supervisor.race_id === 2
                      ? 'Malay'
                      : supervisor.race_id === 3
                      ? 'Indian'
                      : supervisor.race_id === 4
                      ? 'Others'
                      : ''}
                  </p>
                </div>
                <div className="col-sm-4">
                  <strong>Date of Birth</strong>
                  <p className="pt-2">
                    {supervisor.date_of_birth
                      ? moment(supervisor.date_of_birth).format('DD/MM/YYYY')
                      : '-'}
                  </p>
                </div>
              </div>
              <div className="row pb-3">
                <div className="col">
                  <strong>Email</strong>
                  <p className="pt-2">{supervisor.email}</p>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <strong>Phone No</strong>
                  <p className="pt-2">{supervisor.phone_no}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card bg-white text-dark shadow rounded"
        style={{ margin: '3rem' }}
      >
        <div className="card-body">
          <div className="container-fluid d-flex">
            <div style={{ width: '15rem' }} className="p-2 m-2">
              <strong>Assigned To</strong>
              <p className="pt-2 text-muted">
                Manage client and site assignation
              </p>
            </div>
            <div className="flex-grow-1 p-2 m-2">
              <div className="row pb-3">
                <div className="col-sm-12">
                  <strong>Client</strong>
                  <p className="pt-2">
                    {supervisor.client && supervisor.client.name}
                  </p>
                </div>
              </div>
              <div className="row pb-3">
                <div className="col-sm-12">
                  <strong>Site</strong>
                  <div className="d-flex pt-3">
                    {supervisorSites &&
                      supervisorSites.map((site) => (
                        <span
                          key={site.id}
                          className="badge rounded-pill bg-secondary me-2"
                        >
                          {site.name}
                        </span>
                      ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Start Date</strong>
                  <p className="pt-2">{startDate}</p>
                </div>
                <div className="col-sm-4">
                  <strong>Resign Date</strong>
                  <p className="pt-2">{resignDate}</p>
                </div>
                <div className="col-sm-4">
                  <strong>Actual Last Day</strong>
                  <p className="pt-2">{lastDayDate}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SupervisorDetail;
